module.exports = __webpack_public_path__ + "img/dead-tree-desert-06.c15c6320.png";